<button class="sign-in__btn" data-btn="signin">Sign In</button>
<span class="sign-in-up__stick"></span>
<button class="sign-up__btn" data-btn="signup">Sign Up</button>